module.exports = __webpack_public_path__ + "static/img/10010 (2).2c80046.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10010 (2).webp
// module id = 5Uvk
// module chunks = 14